export default function (name, url) {
  if (!(name instanceof Array)) {
    name = [name];
  }

  name.forEach(function (v) {
    url = url.replace(new RegExp("(?:&" + v + "=[^&]*)", "g"), "");
    url = url.replace(new RegExp("(?:\\?" + v + "=[^&]*&?)", "g"), "?");
  });
  return url;
}
